import { useMutation, useQueryClient } from "@tanstack/react-query";
import client from "api/graphql/getClient";
import { graphql } from "gql/gql";
import { useActiveAccount } from "utils/useActiveAccount";
import { DeleteAPIKeyParams } from "gql/graphql";

const deleteAPIKeyDocument = graphql(/* GraphQL */ `
	mutation deleteAPIKey($params: DeleteAPIKeyParams!) {
		deleteAPIKey(params: $params) {
			error {
				code
				message
			}
			success
		}
	}
`);

interface Args {
	params: DeleteAPIKeyParams;
	userId?: string;
}

const deleteAPIKey = ({ userId, params }: Args) =>
	client(userId)
		.request(deleteAPIKeyDocument, { params })
		.then((res) => res.deleteAPIKey);

const useDeleteAPIKey = () => {
	const { _id, userId } = useActiveAccount();
	const queryClient = useQueryClient();

	return useMutation(
		(params: DeleteAPIKeyParams) => deleteAPIKey({ params, userId }),
		{
			onSettled: () => {
				queryClient.invalidateQueries(["user", userId, "account", _id], {
					exact: true,
				});
			},
		}
	);
};

export default useDeleteAPIKey;
